import { Claims, ExternalEnumRecord, claimRequiredInContext, claimsValidInContext } from "../interfaces/APIInterface"
import { useEffect } from 'react';
import { COSMOS_API, POST_ENDPOINT, GET_ENDPOINT } from '../api/API';
import Autocomplete from "@mui/material/Autocomplete";
import { OptionsType } from "../interfaces/ApplicationInterfaces";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

interface ApplicationClaimFieldProps {
    claim: Claims,
    claimValue: string,
    setClaimValue: (appId: string, claimId: string, claimValue: string) => void,
    appId: string,
    appExternalEnums: Record<string, Record<string, ExternalEnumRecord>>;
    disabled: boolean,
    claimContext: Record<string, string>,
    claimSchema: Record<string, Claims>
}

export const ApplicationClaimField = (props: ApplicationClaimFieldProps) => {
    useEffect(() => {
        if (props.claimValue) {
            if (props.claim.userInputType == 'DropdownSingleSelect') {
                if (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined) {
                    let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext);
                    if (!claimsValidForContext.some(cv => cv.value == props.claimValue)) {
                        props.setClaimValue(props.appId, props.claim.id, '');
                    }
                } else if (props.claim.possibleValues && (props.claim.possibleValues.length > 0)) {
                    let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.claim.possibleValues!, props.claimContext);
                    if (!claimsValidForContext.some(cv => cv.value == props.claimValue)) {
                        props.setClaimValue(props.appId, props.claim.id, '');
                    }
                }
            } else if (props.claim.userInputType == 'CheckboxMultiSelect') {
                if (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined) {
                    let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext);
                    let claimVals = props.claimValue.split(",");
                    let validVals = claimVals.filter(claimVal => claimsValidForContext.some(cv => cv.value == claimVal));
                    if (validVals.length != claimVals.length) {
                        props.setClaimValue(props.appId, props.claim.id, validVals.join(","));
                    }
                } else if (props.claim.possibleValues && (props.claim.possibleValues.length > 0)) {
                    let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.claim.possibleValues!, props.claimContext);
                    let claimVals = props.claimValue.split(",");
                    let validVals = claimVals.filter(claimVal => claimsValidForContext.some(cv => cv.value == claimVal));
                    if (validVals.length != claimVals.length) {
                        props.setClaimValue(props.appId, props.claim.id, validVals.join(","));
                    }
                }
            }
        }
    }, [props.claimContext]);

    if (props.claim.userInputType === 'CheckboxMultiSelect' &&
        ((props.claim.possibleValues && props.claim.possibleValues.length > 0) ||
            (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined))) {
        if (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined) {
            let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext);
            return (<Autocomplete
                id={props.claim.id}
                fullWidth
                multiple
                disabled={props.disabled || props.claim.readOnly}
                value={props.claimValue?.split(',').filter(claimVal => claimsValidForContext.some(cv => cv.value == claimVal)).map(cval => { return { value: cval, label: props.appExternalEnums[props.appId][props.claim.id].byValue[cval]?.name, isDisabled: false, hidden: false } })}
                isOptionEqualToValue={(
                    option: OptionsType,
                    value: OptionsType
                ) => option.value === value.value}
                options={
                    claimsValidForContext.map(claimVal => {
                        return { value: claimVal.value, label: claimVal.name, hidden: false, isDisabled: false }
                    })
                }
                getOptionLabel={(option: OptionsType) => option.label}
                renderInput={(params) => (
                    <TextField {...params} label={claimRequiredInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext) ? `${props.claim.name} (Required)` : props.claim.name} />
                )}
                onChange={(
                    _: any,
                    value: OptionsType | OptionsType[] | null
                ) => {
                    props.setClaimValue(props.appId, props.claim.id, value === null ? '' : (
                        (!Array.isArray(value)) ? value.value : value.map(optv => optv.value).join(",")
                    ))
                }}
            />)
        } else {
            let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.claim.possibleValues!, props.claimContext);
            return (<Autocomplete
                id={props.claim.id}
                fullWidth
                multiple
                disabled={props.disabled || props.claim.readOnly}
                value={props.claimValue?.split(',').filter(claimVal => claimsValidForContext.some(cv => cv.value == claimVal)).map(cval => { return { value: cval, label: props.claim?.possibleValues?.find(pv => pv.value == cval)?.name || cval, isDisabled: false, hidden: false } })}
                isOptionEqualToValue={(
                    option: OptionsType,
                    value: OptionsType
                ) => option.value === value.value}
                options={
                    claimsValidForContext.map(pval => {
                        return { value: pval.value, label: pval.name, hidden: false, isDisabled: false }
                    })
                }
                getOptionLabel={(option: OptionsType) => option.label}
                renderInput={(params) => (
                    <TextField {...params} label={claimRequiredInContext(props.claim, props.claimSchema, props.claim.possibleValues, props.claimContext) ? `${props.claim.name} (Required)` : props.claim.name} />
                )}
                onChange={(
                    _: any,
                    value: OptionsType | OptionsType[] | null
                ) => {
                    props.setClaimValue(props.appId, props.claim.id, value === null ? '' : (
                        (!Array.isArray(value)) ? value.value : value.map(optv => optv.value).join(",")
                    ))
                }}
            />)
        }
    }
    else if (
        (props.claim.userInputType === 'DropdownSingleSelect' || props.claim.userInputType === 'RadioSingleSelect') &&
        ((props.claim.possibleValues && props.claim.possibleValues.length > 0) ||
            (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined))
    ) {
        if (props.appExternalEnums[props.appId]?.[props.claim.id] !== undefined) {
            let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext);
            return (
                <TextField
                    name={props.claim.id}
                    fullWidth
                    key={props.claim.id}
                    select
                    disabled={props.disabled || props.claim.readOnly}
                    label={claimRequiredInContext(props.claim, props.claimSchema, props.appExternalEnums[props.appId][props.claim.id].values, props.claimContext) ? `${props.claim.name || props.claim.id} (Required)` : (props.claim.name || props.claim.id)}
                    value={props.claimValue && claimsValidForContext.some(claimVal => claimVal.value == props.claimValue) ? props.claimValue : ''}
                    onChange={(e) =>
                        props.setClaimValue(props.appId, props.claim.id, e.target.value)
                    }
                >
                    {Object.keys(props.appExternalEnums[props.appId][props.claim.id].byValue).includes('') === false ? (
                        <MenuItem
                            key={'appClaimNullVal'}
                            value={''}
                        ></MenuItem>
                    ) : (
                        <></>
                    )}
                    {claimsValidForContext.map(claimVal => (
                        <MenuItem key={claimVal.value} value={claimVal.value}>
                            {claimVal.name}
                        </MenuItem>
                    ))}
                </TextField>
            );
        } else {
            let claimsValidForContext = claimsValidInContext(props.claim, props.claimSchema, props.claim.possibleValues!, props.claimContext);
            return (
                <TextField
                    name={props.claim.id}
                    fullWidth
                    key={props.claim.id}
                    select
                    disabled={props.disabled || props.claim.readOnly}
                    label={claimRequiredInContext(props.claim, props.claimSchema, props.claim.possibleValues, props.claimContext) ? `${props.claim.name || props.claim.id} (Required)` : props.claim.name || props.claim.id}
                    value={props.claimValue && claimsValidForContext.some(claimVal => claimVal.value == props.claimValue) ? props.claimValue : ''}
                    onChange={(e) =>
                        props.setClaimValue(props.appId, props.claim.id, e.target.value)
                    }
                >
                    {props.claim.possibleValues!.map(pv => pv.value).includes('') === false ? (
                        <MenuItem
                            key={'appClaimNullVal'}
                            value={''}
                        ></MenuItem>
                    ) : (
                        <></>
                    )}
                    {claimsValidForContext.map((claimVal) => (
                        <MenuItem key={claimVal.value} value={claimVal.value}>
                            {claimVal.name}
                        </MenuItem>
                    ))}
                </TextField>
            );
        }
    } else {
        return (
            <TextField
                id={props.claim.id}
                key={props.claim.id}
                label={claimRequiredInContext(props.claim, props.claimSchema, props.claim.possibleValues, props.claimContext) ? `${props.claim.name || props.claim.id} (Required)` : props.claim.name || props.claim.id}
                disabled={props.disabled || props.claim.readOnly}
                value={
                    props.claimValue || ''
                }
                onChange={(e) =>
                    props.setClaimValue(props.appId, props.claim.id, e.target.value)
                }
            />
        );
    }
}